import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("cdf_token", data.token);
    // Fase 8 — o backend já entrega `access` (premium_active,
    // premium_pending_review, is_admin) diretamente no /auth/login. Se por
    // qualquer motivo o campo não vier, chamamos /auth/me como fallback
    // ANTES de retornar, para evitar que o ProtectedRoute enxergue user
    // sem access e redirecione erroneamente para /assinatura.
    let u = data.user;
    if (!u || !u.access) {
      try {
        const me = await api.get("/auth/me");
        u = me.data.user;
      } catch { /* mantém u como veio */ }
    }
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("cdf_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
